export default async function getNaturalSize(url) {
  return await new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ height: img.naturalHeight, width: img.naturalWidth });
    img.onerror = e => reject(e);
    img.src = url;
  });
}
